import type { RouteObject } from "react-router";
import DirectoryPage from "./ui/pages/DirectoryPage";
import PublicProfilePage from "./ui/pages/PublicProfilePage";
import { DIRECTORY_PATH } from "./domain/paths";

/**
 * Anonymous routes on the application's own domain. Mounted OUTSIDE
 * ProtectedRoute and AppLayout — nobody is signed in here, and the app chrome
 * assumes someone is.
 */
export const publicDirectoryRoutes: RouteObject[] = [
    { path: DIRECTORY_PATH, element: <DirectoryPage /> },
    { path: `${DIRECTORY_PATH}/:slug`, element: <PublicProfilePage /> },
];
